import { CONFIG_KEYS as e, FOCUSABLE_SELECTOR as t, FOCUSGROUP_DEFAULTS as n, ROLE_DEFAULTS_MAP as r, TOKEN_MAP as i } from "./focusgroup-constants.js";
//#region directives/focusgroup_directive/focusgroup_utils.js
function a(t, n) {
	for (let r of e) n[r] !== void 0 && (t[r] = n[r]);
}
function o(e, t) {
	let n = t.split(/\s+/);
	for (let t of n) {
		let n = i[t];
		n ? e[n.key] = n.value : t && process.env.NODE_ENV !== "production" && console.warn(`[DtFocusgroupDirective] Unknown token "${t}". Valid tokens: ${Object.keys(i).join(", ")}.`);
	}
}
function s(e) {
	let t = { ...n };
	return !e || e === !0 || (typeof e == "object" ? a(t, e) : typeof e == "string" && o(t, e)), t;
}
function c(t, n) {
	return e.every((e) => t[e] === n[e]);
}
function l(e, n) {
	if (n.selector) return n.selector;
	let i = e.getAttribute("role");
	return i && r[i] ? r[i].selector : t;
}
function u(e, t) {
	if (t.skipDisabled !== null) return t.skipDisabled;
	let n = e.getAttribute("role");
	return n && r[n] ? r[n].skipDisabled : !0;
}
//#endregion
export { c as configsEqual, s as parseConfig, l as resolveSelector, u as resolveSkipDisabled };

//# sourceMappingURL=focusgroup-utils.js.map